import { render } from "./CompanySummary.vue?vue&type=template&id=2cf519fe&scoped=true"
import script from "./CompanySummary.vue?vue&type=script&lang=js"
export * from "./CompanySummary.vue?vue&type=script&lang=js"

import "./CompanySummary.vue?vue&type=style&index=0&id=2cf519fe&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf519fe"]])

export default __exports__